<template>
    <div>
        <v-row v-if="supplier" no-gutters>
            <v-col cols="2" class="d-flex align-center">
                <span>Contacts</span>
            </v-col>
            <v-col class="d-flex align-center flex-wrap">
                <ContactSupplier
                    v-for="contact in filterContacts"
                    :key="contact.id"
                    :contact="contact"
                    @removeContact="removeContact"
                    @replaceContact="replaceContact"
                />
                <div>
                    <v-btn
                        depressed
                        fab
                        x-small
                        color="primary"
                        @click="openCreateDialogNew"
                        :disabled="loading"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-dialog
                        :retain-focus="false"
                        v-model="createDialogNew"
                        persistent
                        max-width="600px"
                    >
                        <ContactSupplierForm
                            title="New Contact"
                            :create-form="true"
                            @closeDialog="closeCreateDialogNew"
                            @addContact="addContact"
                            :supplierId="supplier.id"
                        />
                    </v-dialog>
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters v-if="supplier" class="pb-2 pt-2">
            <v-col cols="2" class="d-flex align-center">
                <span>City</span>
            </v-col>
            <v-col class="d-flex align-center">
                <span>{{ supplier.city }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="supplier" class="pb-2">
            <v-col cols="2" class="d-flex align-center">
                <span>Currency</span>
            </v-col>
            <v-col class="d-flex align-center">
                <span
                    >{{ supplier.currency
                    }}{{
                        supplier.currency2 ? ` - ${supplier.currency2}` : ''
                    }}</span
                >
            </v-col>
        </v-row>
        <v-row v-if="supplier" no-gutters class="pb-2">
            <v-col cols="2" class="d-flex align-center">
                <span>Language</span>
            </v-col>
            <v-col class="d-flex align-center">
                <v-avatar size="24" class="me-2 my-1">
                    <v-img
                        :src="
                            supplier.language.toLowerCase() === 'english'
                                ? require('@/assets/usa_flag.png')
                                : require('@/assets/col_flag.png')
                        "
                    />
                </v-avatar>
            </v-col>
        </v-row>
        <v-row v-if="supplier" no-gutters class="pb-2">
            <v-col cols="2" class="d-flex align-center">
                <span>SAP Status</span>
            </v-col>
            <v-col class="d-flex align-center">
                <span>{{ supplier.sapStatus ? 'On SAP' : 'Not on SAP' }}</span>
            </v-col>
        </v-row>
        <v-divider class="my-4" />
        <v-data-table
            class="mt-4 elevation-1"
            :headers="headers"
            :items="sortedItems"
            item-value="id"
            :loading="loading"
            :mobile-breakpoint="0"
            disable-pagination
            hide-default-footer
            fixed-header
        >
            <template v-slot:top>
                <div class="top">
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pt-4 pb-0 pb-4 align-center"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <h1 class="mr-4 ml-5">Evaluations</h1>
                        <v-spacer />
                        <v-btn
                            color="primary"
                            class="d-flex align-center mr-4"
                            rounded
                            @click="openSelectAreaForm({})"
                            :disabled="
                                loading ||
                                    !user.permissions.includes(
                                        'evaluateSupplier'
                                    ) ||
                                    validateMoreEvaluations
                            "
                        >
                            New
                            <v-icon class="ml-1">mdi-plus</v-icon>
                        </v-btn>
                    </v-row>
                </div>
            </template>
            <!-- ITEMS -->
            <template v-slot:[`item.date`]="{ item }">
                <p class="my-0">
                    {{
                        formatDate(
                            item.date.seconds
                                ? item.date.seconds
                                : item.date._seconds
                        )
                    }}
                </p>
            </template>
            <template v-slot:[`item.evaluationType`]="{ item }">
                <p class="my-0">
                    {{
                        item.evaluationType === 'initial'
                            ? 'Initial'
                            : item.evaluationType === 'reevaluation'
                            ? 'Re-evaluation'
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.purchasingEdit`]="{ item }">
                <p class="my-0">
                    {{
                        item.purchasingEdit
                            ? getUserName(item.purchasingEdit)
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.warehouseEdit`]="{ item }">
                <p class="my-0">
                    {{
                        item.warehouseEdit
                            ? getUserName(item.warehouseEdit)
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.sstEdit`]="{ item }">
                <p class="my-0">
                    {{ item.sstEdit ? getUserName(item.sstEdit) : '' }}
                </p>
            </template>
            <template v-slot:[`item.environmentalEdit`]="{ item }">
                <p class="my-0">
                    {{
                        item.environmentalEdit
                            ? getUserName(item.environmentalEdit)
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.totalScore`]="{ item }">
                <p class="my-0">
                    {{
                        (item.purchasingScore || 0) +
                            (item.warehouseScore || 0) +
                            (item.sstScore || 0) +
                            (item.environmentalScore || 0)
                    }}
                </p>
            </template>
            <template v-slot:[`item.actions`]="{ item, index }">
                <v-icon
                    small
                    class="mr-2"
                    @click="openSelectAreaForm(item)"
                    v-if="
                        (!(
                            item.warehouseClosed &&
                            item.sstClosed &&
                            item.purchasingClosed &&
                            item.environmentalClosed
                        ) ||
                            (user.permissions.includes(
                                'editEvaluationSupplier'
                            ) &&
                                index === 0)) &&
                            user.permissions.includes('evaluateSupplier')
                    "
                >
                    mdi-pencil
                </v-icon>

                <v-icon
                    small
                    class="mr-2"
                    @click="openPDF(item)"
                    v-if="
                        item.warehouseClosed &&
                            item.sstClosed &&
                            item.purchasingClosed &&
                            item.environmentalClosed &&
                            user.permissions.includes('evaluateSupplier')
                    "
                >
                    mdi-file-pdf-box
                </v-icon>
            </template>
        </v-data-table>
        <v-dialog persistent fullscreen v-model="openForm">
            <SupplierEvaluationForm
                v-if="openForm"
                :supplier="supplier"
                :questions="questionsForm"
                :typeForm="workArea"
                :evaluationInfo="evaluation"
                :editEvaluation="editEvaluation"
                :initialEvaluation="initialEvaluation"
                @updateEvaluation="updateEvaluations"
                @close="closeEvaluationForm"
            />
        </v-dialog>
        <v-dialog persistent v-model="selectAreaForm" max-width="400px">
            <v-card>
                <v-card-title ref="title" class="sticky-header">
                    <v-btn
                        small
                        icon
                        @click="closeSelectAreaForm"
                        color="primary"
                        class="mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h3>{{ 'Select Area' }}</h3>
                </v-card-title>

                <v-card-text class="mt-4">
                    <v-form v-model="valid" class="py-2 mt-0 pt-0 mb-2">
                        <v-select
                            v-if="!validateMoreEvaluations"
                            v-model="workArea"
                            :items="[
                                { text: 'Purchasing', value: 'purchasing' },
                                { text: 'Warehouse', value: 'warehouse' },
                                { text: 'SST', value: 'sst' },
                                {
                                    text: 'Environmental',
                                    value: 'environmental',
                                },
                            ]"
                            item-text="text"
                            item-value="value"
                            prepend-icon="mdi-tools"
                            label="Area"
                            hide-details
                            :menu-props="{ bottom: true, offsetY: true }"
                            :disabled="loading"
                        />
                        <v-select
                            v-else
                            v-model="workArea"
                            :items="areasAvailable"
                            item-text="text"
                            item-value="value"
                            prepend-icon="mdi-tools"
                            label="Area"
                            hide-details
                            :menu-props="{ bottom: true, offsetY: true }"
                            :disabled="loading"
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        rounded
                        class="mt-n2 mr-3 white--text mb-4"
                        :loading="loading"
                        @click="openEvaluationForm"
                        :disabled="workArea === ''"
                    >
                        Generate Form
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ContactSupplierForm from '@/components/Suppliers/ContactSupplierForm'
import ContactSupplier from '@/components/Suppliers/ContactSupplier'
import codesCurrency from '@/assets/codes-all_json.json'
import { mapMutations } from 'vuex'
import API from '@/services/api'
import { storage } from '@/services/firebase'
import SupplierEvaluationForm from '@/components/Suppliers/SupplierEvaluationForm'
import _ from 'lodash'
import { printEvaluationPDF } from './ReportEvaluationSupplier'
import moment from 'moment'

export default {
    name: 'SupplierGeneralInfo',
    components: {
        ContactSupplierForm,
        ContactSupplier,
        SupplierEvaluationForm,
    },
    props: {
        id: String,
        supplier: Object,
        questions: Array,
    },
    data() {
        return {
            editEvaluation: false,
            initialEvaluation: false,
            workArea: '',
            user: {},
            dialogExchange: false,
            selectAreaForm: false,
            valid: false,
            openForm: false,
            createDialogNew: false,
            itemsCurrency: null,
            loading: false,
            error: false,
            errorMsg: null,
            companyId: JSON.parse(localStorage.getItem('company')),
            folderPictures: 'suppliers_pictures',
            val: false,
            headers: [
                {
                    text: 'Date',
                    value: 'date',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Type of Evaluation',
                    value: 'evaluationType',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Purchasing Evaluator',
                    value: 'purchasingEdit',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Purchasing Evaluation',
                    value: 'purchasingScore',
                    align: 'center',
                    sortable: false,
                    width: '100',
                },
                {
                    text: 'Warehouse Evaluator',
                    value: 'warehouseEdit',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Warehouse Evaluation',
                    value: 'warehouseScore',
                    align: 'center',
                    sortable: false,
                    width: '100',
                },
                {
                    text: 'SST Evaluator',
                    value: 'sstEdit',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'SST Evaluation',
                    value: 'sstScore',
                    align: 'center',
                    sortable: false,
                    width: '100',
                },
                {
                    text: 'Environmental Evaluator',
                    value: 'environmentalEdit',
                    align: 'center',
                    sortable: false,
                    width: '120',
                },
                {
                    text: 'Environmental Evaluation',
                    value: 'environmentalScore',
                    align: 'center',
                    sortable: false,
                    width: '100',
                },
                {
                    text: 'Score',
                    value: 'totalScore',
                    align: 'center',
                    sortable: false,
                    width: '80',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: '80',
                },
            ],
            items: [],
            questionsForm: [],
            evaluation: {},
            areasAvailable: [],
            usersBD: [],
        }
    },
    watch: {
        supplier: async function() {
            await this.getContactsBySupplier()
            await this.getEvaluations()
            this.val = false
            this.val = true
        },
        questions: {
            handler(newValue) {
                this.questionsForm = _.cloneDeep(newValue)
            },
            deep: true,
        },
    },
    computed: {
        filterContacts: function() {
            return this.val ? this.supplier.contacts : []
        },
        validateMoreEvaluations() {
            if (!this.items || !this.items.length) return false
            const currentYear = new Date().getFullYear()
            const getItemYear = item => {
                const d = item.date
                if (!d) return null
                const seconds = d.seconds ?? d._seconds
                const nanoseconds = d.nanoseconds ?? d._nanoseconds
                if (seconds == null) return null
                const ms = seconds * 1000 + Math.floor((nanoseconds || 0) / 1e6)
                return new Date(ms).getFullYear()
            }
            const evaluationsThisYear = this.items.filter(
                item => getItemYear(item) === currentYear
            )
            const initialInSameYear = evaluationsThisYear.filter(
                item => item.evaluationType === 'initial'
            )
            if (initialInSameYear.length > 1) {
                return true
            }
            if (evaluationsThisYear.length === 0) return false
            if (evaluationsThisYear.length === 1) {
                const item = evaluationsThisYear[0]
                const isClosed =
                    item.environmentalClosed &&
                    item.sstClosed &&
                    item.purchasingClosed &&
                    item.warehouseClosed
                if (isClosed) return false
            }
            return true
        },
        sortedItems() {
            return [...this.items].sort((a, b) => {
                // Normalizar la fecha (seconds o _seconds)
                const aDate = a.date?.seconds || a.date?._seconds || 0
                const bDate = b.date?.seconds || b.date?._seconds || 0

                // De más reciente a más antiguo
                return bDate - aDate
            })
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        openCreateDialogNew: function() {
            this.createDialogNew = true
        },
        async openEvaluationForm() {
            try {
                this.loading = true
                if (
                    !this.questionsForm ||
                    !Array.isArray(this.questionsForm) ||
                    this.questionsForm.length
                ) {
                    this.questionsForm = await API.getSupplierQuestions({
                        language: 'spanish',
                    })
                }
                this.closeSelectAreaForm()
                this.openForm = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async openSelectAreaForm(item) {
            if (
                item &&
                item.purchasingClosed &&
                item.warehouseClosed &&
                item.sstClosed &&
                item.environmentalClosed &&
                this.user.permissions.includes('editEvaluationSupplier')
            ) {
                this.editEvaluation = true
                this.evaluation = _.cloneDeep(item)
                this.workArea = 'purchasing'
                this.openEvaluationForm()
                return
            }
            if (Object.keys(item).length === 0) {
                this.editEvaluation = false
                this.initialEvaluation = this.getEvaluationType()
                this.evaluation = {}
            } else {
                this.editEvaluation = true
                this.evaluation = _.cloneDeep(item)
                this.areasAvailable = this.getAvailableAreas(item)
            }
            this.workArea = ''
            this.selectAreaForm = true
        },
        getEvaluationType() {
            if (!this.items || !this.items.length) return true
            const currentYear = new Date().getFullYear()
            const getItemDate = item => {
                const d = item.date
                if (!d) return null
                const seconds = d.seconds ?? d._seconds
                const nanoseconds = d.nanoseconds ?? d._nanoseconds ?? 0
                if (seconds == null) return null
                return new Date(seconds * 1000 + Math.floor(nanoseconds / 1e6))
            }
            const lastItem = this.items.reduce((latest, item) => {
                const dateObj = getItemDate(item)
                if (!dateObj) return latest
                if (!latest) return { item, date: dateObj }
                return dateObj > latest.date ? { item, date: dateObj } : latest
            }, null)
            if (!lastItem) return true
            const hasCompletedInitial = this.items.some(
                ev =>
                    ev.evaluationType === 'initial' &&
                    ev.purchasingClosed &&
                    ev.warehouseClosed &&
                    ev.sstClosed &&
                    ev.environmentalClosed
            )
            const lastInSameYear = lastItem.date.getFullYear() === currentYear
            if (lastInSameYear && !hasCompletedInitial) return true
            return !lastInSameYear
        },
        getAvailableAreas(item) {
            const areas = [
                { text: 'Purchasing', value: 'purchasing' },
                { text: 'Warehouse', value: 'warehouse' },
                { text: 'SST', value: 'sst' },
                { text: 'Environmental', value: 'environmental' },
            ]

            return areas.filter(area => {
                const key = area.value + 'Closed'
                return !item[key]
            })
        },

        openDialogExchange: function() {
            this.dialogExchange = true
        },
        async openPDF(item) {
            try {
                this.loading = true
                const questionsForm = await API.getSupplierQuestions({
                    language: 'spanish',
                })
                const blob = await printEvaluationPDF(
                    questionsForm,
                    item,
                    this.supplier,
                    false
                )
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `supplier_evaluation_${this.supplier.name ||
                    ''}_${item.evaluationType || ''}.pdf`
                a.click()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async getEvaluations() {
            try {
                this.loading = true
                if (this.supplier.id) {
                    this.items = await API.getSupplierEvaluations({
                        supplierId: this.supplier.id,
                    })
                } else {
                    this.items = []
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async updateEvaluations(evaluation) {
            try {
                this.loading = true
                const index = this.items.findIndex(
                    item => item.id === evaluation.id
                )
                if (index === -1) {
                    await this.getEvaluations()
                } else {
                    this.$set(this.items, index, {
                        ...this.items[index],
                        ...evaluation,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        getUserName(id) {
            if (this.usersBD.length > 0 && id) {
                return this.usersBD.find(user => user.id == id)?.name
            } else {
                return ''
            }
        },
        selectCurrency: function(event) {
            if (this.supplier.exchange) {
                this.supplier.exchange.currency = event
            } else {
                this.supplier.exchange = { currency: event }
            }
        },
        selectMoney: function(event) {
            if (this.supplier.exchange) {
                this.supplier.exchange.money = event
            } else {
                this.supplier.exchange = { money: event }
            }
        },
        closeCreateDialogNew: function() {
            this.createDialogNew = false
        },
        closeEvaluationForm() {
            this.openForm = false
        },
        closeSelectAreaForm() {
            this.selectAreaForm = false
        },
        closeDialogExchange: function() {
            this.dialogExchange = false
        },
        addContact: function(contact) {
            this.supplier.contacts.push(contact)
        },
        removeContact: function(id) {
            const index = this.supplier.contacts.findIndex(u => u.id === id)
            this.supplier.contacts.splice(index, 1)
            this.val = false
            this.val = true
        },
        replaceContact: function(id, contact) {
            const index = this.supplier.contacts.findIndex(u => u.id === id)
            this.supplier.contacts.splice(index, 1, contact)
            this.val = false
            this.val = true
        },
        saveExchange: async function() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = null
                const { id } = this.supplier
                const supplier = await API.updateSupplier(id, {
                    exchange: this.supplier.exchange,
                })
                supplier.projects = this.supplier.projects
                supplier.contacts = this.supplier.contacts
                supplier.companyRoles = this.supplier.companyRoles
                supplier.profilePicURL = this.supplier.profilePicURL
                this.closeDialogExchange()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async getContactsBySupplier() {
            try {
                this.loading = true
                const contacts = await API.getContactsBySupplier({
                    supplierId: this.supplier.id,
                })
                for (const contact of contacts) {
                    if (contact.picture) {
                        const path = `${this.companyId}/${this.folderPictures}`
                        const storageRef = storage().ref(path)
                        const profilePicRef = storageRef.child(contact.picture)
                        await profilePicRef
                            .getDownloadURL()
                            .then(url => {
                                contact.profilePicURL = url
                            })
                            .catch(error => {
                                contact.profilePicURL = ''
                                return error && true
                            })
                    }
                }
                this.supplier.contacts = contacts || []
                this.val = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
    async created() {
        try {
            this.loading = true
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            const {
                data: { users },
            } = await API.getUsers()
            this.usersBD = users
            await this.getContactsBySupplier()
            await this.getEvaluations()
            this.itemsCurrency = codesCurrency.map(x => x.AlphabeticCode)
            this.questionsForm = this.questions
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
}
</script>

<style scoped>
.text-singleline {
    line-height: 0.75rem;
}
</style>
